import(/* webpackMode: "eager" */ "/var/www/static-website/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/var/www/static-website/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/var/www/static-website/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/var/www/static-website/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/layout/PageLayout/PageLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/organisms/CookieModal/CookieModalPL.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/organisms/CookieModal/CookieModalRO.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NAVIGATION_CONFIG"] */ "/var/www/static-website/src/static/content/pl/navigation.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/static-website/src/styles/cookiebot.css");
